import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PeriodsRoutingModule } from './periods-routing.module';
import { PeriodComponent } from './period/period.component';
import { SharedModule } from '../shared/shared.module';
import { VariableFilterPipe } from './period/variable-filter.pipe';

@NgModule({
  declarations: [
    PeriodComponent,
    VariableFilterPipe
  ],
  imports: [
    CommonModule,
    PeriodsRoutingModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class PeriodsModule { }
